import { render, staticRenderFns } from "./MenuLinkContentWidgetInput.vue?vue&type=template&id=4c375a78&scoped=true"
import script from "./MenuLinkContentWidgetInput.vue?vue&type=script&lang=js"
export * from "./MenuLinkContentWidgetInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c375a78",
  null
  
)

export default component.exports